export { default as WordBank } from './WordBank';
